/** @format */

import { Directive, HostListener, Input } from '@angular/core';

import { AnalyticsService } from '@shared/data-access/services';

@Directive({
  standalone: true,
  selector: '[commonAnalyticsClick]',
})
export class AnalyticsClickDirective {
  @Input('commonAnalyticsClick') eventName: string;
  @Input() actionType: string;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  @HostListener('click', ['$event']) onClick(event: MouseEvent) {
    this.analyticsService.setEventType(this.eventName);
    if (this.actionType) {
      this.analyticsService.setActionType(this.actionType);
    }
    this.analyticsService.triggerAnalyticsEvent(this.eventName);
  }

  constructor(private analyticsService: AnalyticsService) {}
}
